"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WsAiHubUseCaseDetails = void 0;
var react_1 = __importStar(require("react"));
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
var react_router_dom_1 = require("react-router-dom");
var FileSaver = __importStar(require("file-saver"));
var react_markdown_preview_1 = __importDefault(require("@uiw/react-markdown-preview"));
require("@uiw/react-markdown-preview/markdown.css");
var config_1 = require("../config");
var ai_hub_readiness_api_service_1 = __importDefault(require("../shared/services/ai-hub-readiness-api.service"));
var ai_hub_use_case_output_api_service_1 = __importDefault(require("../shared/services/ai-hub-use-case-output-api.service"));
var AiHubLoadingState_1 = require("../shared/AiHubLoadingState");
var UseCaseAlignment_1 = require("../UseCaseAlignment/UseCaseAlignment");
require("./styles/use-case-details.scss");
var use_case_details_utils_1 = require("./utils/use-case-details-utils");
var use_case_details_constants_1 = require("./utils/use-case-details-constants");
var markdown_highlight_components_1 = require("./utils/markdown-highlight-components");
var use_case_highlights_service_1 = require("./services/use-case-highlights.service");
var extraction_run_service_1 = require("./services/extraction-run.service");
var manual_elements_service_1 = require("./services/manual-elements.service");
var hooks_1 = require("../shared/hooks");
var SelectionPopup_1 = require("./components/SelectionPopup/SelectionPopup");
var PrioritisationSection_1 = require("./components/PrioritisationSection/PrioritisationSection");
var ReadlinessCharts_1 = require("./components/ReadlinessCharts/ReadlinessCharts");
var SummarySection_1 = require("./components/SummarySection/SummarySection");
var FlowBar_1 = require("../FlowBar/FlowBar");
var Timeline_1 = require("./components/Timeline/Timeline");
var DlaTree_1 = require("./components/DlaTree/DlaTree");
var READINESS_UPDATED_EVENT = 'ws-ai-hub:readiness-updated';
var DLA_PENDING_MESSAGE = 'DLA artefacts are being prepared. This view updates automatically once required work items are available.';
var buildAdoWorkItemUrl = function (workItemId) {
    return "https://dev.azure.com/" + encodeURIComponent(use_case_details_constants_1.AZURE_DEVOPS_ORGANISATION) + "/" + encodeURIComponent('Delivery Lifecycle Accelerator') + "/_workitems/edit/" + encodeURIComponent(workItemId);
};
var mapElementToReadinessItem = function (element, idPrefix) {
    var normalizedElementId = element.id.trim().toLowerCase();
    var displayName = element.name.trim().length > 0 ? element.name.trim() : normalizedElementId;
    return {
        id: idPrefix + "-" + normalizedElementId,
        label: displayName,
        isReady: element.isReady === true,
    };
};
/**
 * Rich use case details page with report tabs and multi-pane reading controls.
 */
var WsAiHubUseCaseDetails = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var params = react_router_dom_1.useParams();
    var _k = react_1.useState(null), useCaseOutput = _k[0], setUseCaseOutput = _k[1];
    var _l = react_1.useState(true), isLoadingOutput = _l[0], setIsLoadingOutput = _l[1];
    var _m = react_1.useState(''), outputError = _m[0], setOutputError = _m[1];
    var _o = react_1.useState(window.innerWidth), viewportWidth = _o[0], setViewportWidth = _o[1];
    var _p = react_1.useState(window.innerHeight), viewportHeight = _p[0], setViewportHeight = _p[1];
    var _q = react_1.useState(1), selectedColumnCount = _q[0], setSelectedColumnCount = _q[1];
    var _r = react_1.useState(['info']), paneTabKeys = _r[0], setPaneTabKeys = _r[1];
    var _s = react_1.useState(5), fontScaleIndex = _s[0], setFontScaleIndex = _s[1];
    var _t = react_1.useState(use_case_details_constants_1.clampMultiColumnPaneHeight(window.innerHeight - use_case_details_constants_1.MULTI_COLUMN_PANE_VERTICAL_OFFSET)), multiColumnPaneHeight = _t[0], setMultiColumnPaneHeight = _t[1];
    var _u = react_1.useState(false), isResizingColumns = _u[0], setIsResizingColumns = _u[1];
    var _v = react_1.useState(false), isOptimising = _v[0], setIsOptimising = _v[1];
    var _w = react_1.useState(false), isAnalysing = _w[0], setIsAnalysing = _w[1];
    var _x = react_1.useState(false), isSyncingAnalysis = _x[0], setIsSyncingAnalysis = _x[1];
    var _y = react_1.useState(null), extractionRunStatus = _y[0], setExtractionRunStatus = _y[1];
    var _z = react_1.useState(null), actionMessage = _z[0], setActionMessage = _z[1];
    var _0 = react_1.useState(null), activeHeadingId = _0[0], setActiveHeadingId = _0[1];
    var _1 = react_1.useState(0), readingProgress = _1[0], setReadingProgress = _1[1];
    var _2 = react_1.useState([]), highlightItems = _2[0], setHighlightItems = _2[1];
    var _3 = react_1.useState(null), selectionAnchor = _3[0], setSelectionAnchor = _3[1];
    var _4 = react_1.useState(false), isSavingSelection = _4[0], setIsSavingSelection = _4[1];
    var _5 = react_1.useState([]), technologyReadinessItems = _5[0], setTechnologyReadinessItems = _5[1];
    var _6 = react_1.useState([]), dataSourceReadinessItems = _6[0], setDataSourceReadinessItems = _6[1];
    var _7 = react_1.useState(null), readinessTotalScore = _7[0], setReadinessTotalScore = _7[1];
    var readerRootRef = react_1.useRef(null);
    var useCase = (_a = props.useCases) === null || _a === void 0 ? void 0 : _a.find(function (item) { return item.id === params.useCaseId; });
    var strategies = hooks_1.useStrategies().data;
    // Fetch entity highlights for this use case so the markdown reader
    // can wrap real element references with `<HighlightedTerm>` (and
    // open the popup with real backend data on click). A failed or
    // empty response just leaves the markdown un-decorated.
    react_1.useEffect(function () {
        var cancelled = false;
        if (!params.useCaseId) {
            setHighlightItems([]);
            return undefined;
        }
        use_case_highlights_service_1.fetchUseCaseHighlights(params.useCaseId).then(function (items) {
            if (!cancelled) {
                setHighlightItems(items);
            }
        });
        return function () {
            cancelled = true;
        };
    }, [params.useCaseId]);
    // Rebuilds the regex + alias index only when the items array
    // identity changes — cheap O(n) on highlights, n is typically
    // <100 per use case.
    var markdownComponents = react_1.useMemo(function () {
        return markdown_highlight_components_1.buildMarkdownHighlightComponents({
            items: highlightItems,
            useCaseId: params.useCaseId,
            workflowId: useCase === null || useCase === void 0 ? void 0 : useCase.workflow,
        });
    }, [highlightItems, params.useCaseId, useCase === null || useCase === void 0 ? void 0 : useCase.workflow]);
    var inlineTextHighlighter = react_1.useMemo(function () {
        return markdown_highlight_components_1.buildInlineTextHighlighter({
            items: highlightItems,
            useCaseId: params.useCaseId,
            workflowId: useCase === null || useCase === void 0 ? void 0 : useCase.workflow,
        });
    }, [highlightItems, params.useCaseId, useCase === null || useCase === void 0 ? void 0 : useCase.workflow]);
    var useCaseMetricNames = react_1.useMemo(function () {
        var uniqueMetricNames = new Set();
        highlightItems.forEach(function (item) {
            if (item.elementType !== 'metric') {
                return;
            }
            var normalizedName = item.canonicalName.trim().toLowerCase();
            if (normalizedName.length > 0) {
                uniqueMetricNames.add(normalizedName);
            }
        });
        return Array.from(uniqueMetricNames.values());
    }, [highlightItems]);
    var useCaseMetrics = react_1.useMemo(function () {
        var metricsByNormalizedName = new Map();
        highlightItems.forEach(function (item) {
            if (item.elementType !== 'metric') {
                return;
            }
            var displayName = item.canonicalName.trim();
            var normalizedName = displayName.toLowerCase();
            if (normalizedName.length > 0 && !metricsByNormalizedName.has(normalizedName)) {
                metricsByNormalizedName.set(normalizedName, displayName);
            }
        });
        return Array.from(metricsByNormalizedName.values());
    }, [highlightItems]);
    var useCaseTitle = ((_b = useCaseOutput === null || useCaseOutput === void 0 ? void 0 : useCaseOutput.AiUseCase) === null || _b === void 0 ? void 0 : _b.title) || (useCase === null || useCase === void 0 ? void 0 : useCase.title) || '';
    var tabs = react_1.useMemo(function () {
        return useCase ? use_case_details_utils_1.buildUseCaseDetailTabs(useCase, useCaseOutput, strategies) : [];
    }, [strategies, useCase, useCaseOutput]);
    var processTimelinePoints = react_1.useMemo(function () {
        return use_case_details_utils_1.buildProcessTimelinePoints(useCaseOutput);
    }, [useCaseOutput]);
    var readinessWorkflowId = react_1.useMemo(function () {
        var _a;
        var candidates = [useCase === null || useCase === void 0 ? void 0 : useCase.workflow, (_a = useCaseOutput === null || useCaseOutput === void 0 ? void 0 : useCaseOutput.AiUseCase) === null || _a === void 0 ? void 0 : _a.workflow, 'ukdc'];
        for (var _i = 0, candidates_1 = candidates; _i < candidates_1.length; _i++) {
            var candidate = candidates_1[_i];
            if (typeof candidate === 'string' && candidate.trim().length > 0) {
                return candidate.trim();
            }
        }
        return '';
    }, [useCase === null || useCase === void 0 ? void 0 : useCase.workflow, (_c = useCaseOutput === null || useCaseOutput === void 0 ? void 0 : useCaseOutput.AiUseCase) === null || _c === void 0 ? void 0 : _c.workflow]);
    var alignmentWorkflowId = react_1.useMemo(function () {
        var _a;
        if (typeof (useCase === null || useCase === void 0 ? void 0 : useCase.workflow) === 'string' && useCase.workflow.trim().length > 0) {
            return useCase.workflow.trim();
        }
        if (typeof ((_a = useCaseOutput === null || useCaseOutput === void 0 ? void 0 : useCaseOutput.AiUseCase) === null || _a === void 0 ? void 0 : _a.workflow) === 'string' &&
            useCaseOutput.AiUseCase.workflow.trim().length > 0) {
            return useCaseOutput.AiUseCase.workflow.trim();
        }
        return 'ukdc';
    }, [useCase === null || useCase === void 0 ? void 0 : useCase.workflow, (_d = useCaseOutput === null || useCaseOutput === void 0 ? void 0 : useCaseOutput.AiUseCase) === null || _d === void 0 ? void 0 : _d.workflow]);
    var refreshReadinessItems = react_1.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, elements, readinessScore, technologyItems, dataItems, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!params.useCaseId || !readinessWorkflowId) {
                        setTechnologyReadinessItems([]);
                        setDataSourceReadinessItems([]);
                        setReadinessTotalScore(null);
                        return [2 /*return*/];
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Promise.all([
                            ai_hub_readiness_api_service_1.default.getUseCaseElementDetails(readinessWorkflowId, params.useCaseId),
                            ai_hub_readiness_api_service_1.default
                                .getUseCaseReadinessScore(readinessWorkflowId, params.useCaseId)
                                .catch(function () { return null; }),
                        ])];
                case 2:
                    _a = _c.sent(), elements = _a[0], readinessScore = _a[1];
                    technologyItems = elements
                        .filter(function (element) { return element.id.indexOf('tech:') === 0; })
                        .map(function (element) { return mapElementToReadinessItem(element, 'technology'); });
                    dataItems = elements
                        .filter(function (element) { return element.id.indexOf('data:') === 0; })
                        .map(function (element) { return mapElementToReadinessItem(element, 'data-source'); });
                    setTechnologyReadinessItems(technologyItems);
                    setDataSourceReadinessItems(dataItems);
                    setReadinessTotalScore(readinessScore);
                    return [3 /*break*/, 4];
                case 3:
                    _b = _c.sent();
                    setTechnologyReadinessItems([]);
                    setDataSourceReadinessItems([]);
                    setReadinessTotalScore(null);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [params.useCaseId, readinessWorkflowId]);
    react_1.useEffect(function () {
        void refreshReadinessItems();
    }, [refreshReadinessItems]);
    react_1.useEffect(function () {
        var handleReadinessUpdated = function (event) {
            var customEvent = event;
            var detail = (customEvent.detail || {});
            if (detail.useCaseId !== params.useCaseId) {
                return;
            }
            if (detail.workflowId && readinessWorkflowId && detail.workflowId !== readinessWorkflowId) {
                return;
            }
            void refreshReadinessItems();
        };
        window.addEventListener(READINESS_UPDATED_EVENT, handleReadinessUpdated);
        return function () {
            window.removeEventListener(READINESS_UPDATED_EVENT, handleReadinessUpdated);
        };
    }, [params.useCaseId, readinessWorkflowId, refreshReadinessItems]);
    var mergedUseCaseFields = react_1.useMemo(function () {
        var _a;
        var normalizeFieldMap = function (value) {
            if (!value || typeof value !== 'object') {
                return {};
            }
            return Object.entries(value).reduce(function (result, _a) {
                var key = _a[0], fieldValue = _a[1];
                if (fieldValue === null || fieldValue === undefined) {
                    return result;
                }
                result[key] = "" + fieldValue;
                return result;
            }, {});
        };
        var fromList = normalizeFieldMap(useCase === null || useCase === void 0 ? void 0 : useCase.fields);
        var fromOutput = normalizeFieldMap((_a = useCaseOutput === null || useCaseOutput === void 0 ? void 0 : useCaseOutput.AiUseCase) === null || _a === void 0 ? void 0 : _a.fields);
        return __assign(__assign({}, fromList), fromOutput);
    }, [useCase === null || useCase === void 0 ? void 0 : useCase.fields, (_e = useCaseOutput === null || useCaseOutput === void 0 ? void 0 : useCaseOutput.AiUseCase) === null || _e === void 0 ? void 0 : _e.fields]);
    var normalizedUseCaseFieldKeys = react_1.useMemo(function () {
        return Object.keys(mergedUseCaseFields).map(function (fieldKey) { return fieldKey.toLowerCase(); });
    }, [mergedUseCaseFields]);
    var hasAnyUseCaseFields = normalizedUseCaseFieldKeys.length > 0;
    var hasObjectiveField = react_1.useMemo(function () {
        return Object.entries(mergedUseCaseFields).some(function (_a) {
            var key = _a[0], value = _a[1];
            return (key.toLowerCase() === 'objective' && typeof value === 'string' && value.trim().length > 0);
        });
    }, [mergedUseCaseFields]);
    var hasReportField = react_1.useMemo(function () {
        return Object.entries(mergedUseCaseFields).some(function (_a) {
            var key = _a[0], value = _a[1];
            return (key.toLowerCase().includes('report') && typeof value === 'string' && value.trim().length > 0);
        });
    }, [mergedUseCaseFields]);
    var hasReportTextInOutput = react_1.useMemo(function () {
        var useCaseResults = (useCaseOutput === null || useCaseOutput === void 0 ? void 0 : useCaseOutput.UseCaseResults) || [];
        return useCaseResults.some(function (result) { return ("" + (result.Text || '')).trim().length > 0; });
    }, [useCaseOutput === null || useCaseOutput === void 0 ? void 0 : useCaseOutput.UseCaseResults]);
    var isOptimiseActionReady = hasObjectiveField || hasReportField || hasReportTextInOutput;
    var isStartAnalysisActionReady = hasReportField || hasReportTextInOutput;
    var isSyncAnalysisActionReady = isStartAnalysisActionReady;
    var isPopupHighlightDataReady = highlightItems.length > 0;
    var isQualificationStepReady = isOptimiseActionReady && isStartAnalysisActionReady && isSyncAnalysisActionReady;
    var isPrioritizationStepReady = hasAnyUseCaseFields && normalizedUseCaseFieldKeys.includes('prioritisation');
    var maxReaderColumns = use_case_details_utils_1.getMaxReaderColumns(viewportWidth);
    var visibleColumnCount = Math.min(selectedColumnCount, maxReaderColumns);
    var activeTabKey = paneTabKeys[0] || 'info';
    var targetSystemWorkItemId = ((_f = useCaseOutput === null || useCaseOutput === void 0 ? void 0 : useCaseOutput.Draft) === null || _f === void 0 ? void 0 : _f.TargetSystemID) || null;
    var resizeStartRef = react_1.useRef(null);
    var sidebarInnerRef = react_1.useRef(null);
    var refreshOutput = react_1.useCallback(function (showLoader) {
        if (showLoader === void 0) { showLoader = true; }
        return __awaiter(void 0, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (showLoader) {
                            setIsLoadingOutput(true);
                        }
                        return [4 /*yield*/, ai_hub_use_case_output_api_service_1.default.getUseCaseOutput(params.useCaseId)];
                    case 1:
                        result = _a.sent();
                        if (result) {
                            setUseCaseOutput(result);
                            setOutputError('');
                        }
                        else {
                            setUseCaseOutput(null);
                            setOutputError('Detailed generated content is not available yet for this use case.');
                        }
                        if (showLoader) {
                            setIsLoadingOutput(false);
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    }, [params.useCaseId]);
    react_1.useEffect(function () {
        var handleResize = function () {
            setViewportWidth(window.innerWidth);
            setViewportHeight(window.innerHeight);
        };
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    react_1.useEffect(function () {
        setMultiColumnPaneHeight(function (currentHeight) {
            return use_case_details_constants_1.clampMultiColumnPaneHeight(currentHeight);
        });
    }, [viewportHeight]);
    react_1.useEffect(function () {
        if (!isResizingColumns) {
            return;
        }
        var handleMouseMove = function (event) {
            var resizeStart = resizeStartRef.current;
            if (!resizeStart) {
                return;
            }
            var deltaY = event.clientY - resizeStart.startY;
            setMultiColumnPaneHeight(use_case_details_constants_1.clampMultiColumnPaneHeight(resizeStart.startHeight + deltaY));
        };
        var stopResizing = function () {
            setIsResizingColumns(false);
            resizeStartRef.current = null;
            document.body.style.cursor = '';
            document.body.style.userSelect = '';
        };
        document.body.style.cursor = 'ns-resize';
        document.body.style.userSelect = 'none';
        window.addEventListener('mousemove', handleMouseMove);
        window.addEventListener('mouseup', stopResizing);
        return function () {
            document.body.style.cursor = '';
            document.body.style.userSelect = '';
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', stopResizing);
        };
    }, [isResizingColumns, viewportHeight]);
    react_1.useEffect(function () {
        var isMounted = true;
        var loadOutput = function () { return __awaiter(void 0, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ai_hub_use_case_output_api_service_1.default.getUseCaseOutput(params.useCaseId)];
                    case 1:
                        result = _a.sent();
                        if (!isMounted) {
                            return [2 /*return*/];
                        }
                        if (result) {
                            setUseCaseOutput(result);
                            setOutputError('');
                        }
                        else {
                            setUseCaseOutput(null);
                            setOutputError('Detailed generated content is not available yet for this use case.');
                        }
                        setIsLoadingOutput(false);
                        return [2 /*return*/];
                }
            });
        }); };
        loadOutput();
        return function () {
            isMounted = false;
        };
    }, [params.useCaseId]);
    react_1.useEffect(function () {
        if (tabs.length === 0) {
            return;
        }
        var nextPaneKeys = use_case_details_utils_1.buildDefaultPaneTabKeys(tabs, visibleColumnCount);
        setPaneTabKeys(function (currentKeys) {
            var mergedKeys = nextPaneKeys.map(function (defaultKey, index) {
                var currentKey = currentKeys[index];
                var tabExists = tabs.some(function (tab) { return tab.key === currentKey; });
                return tabExists ? currentKey : defaultKey;
            });
            return mergedKeys;
        });
    }, [tabs, visibleColumnCount]);
    react_1.useEffect(function () {
        if (selectedColumnCount > maxReaderColumns) {
            setSelectedColumnCount(maxReaderColumns);
        }
    }, [maxReaderColumns, selectedColumnCount]);
    react_1.useEffect(function () {
        var nextDefaultScale = use_case_details_constants_1.DEFAULT_FONT_SCALE_BY_COLUMN_COUNT[visibleColumnCount] || 100;
        var nextFontScaleIndex = use_case_details_constants_1.FONT_SCALE_OPTIONS.findIndex(function (value) { return value === nextDefaultScale; });
        if (nextFontScaleIndex >= 0) {
            setFontScaleIndex(nextFontScaleIndex);
        }
    }, [visibleColumnCount]);
    react_1.useEffect(function () {
        if (visibleColumnCount !== 1) {
            setActiveHeadingId(null);
            setReadingProgress(0);
            return;
        }
        var activeTab = tabs.find(function (t) { return t.key === activeTabKey; });
        if (!activeTab || activeTab.headings.length === 0) {
            setActiveHeadingId(null);
            setReadingProgress(0);
            return;
        }
        var paneKey = 'pane-1';
        // Resolve section elements lazily — markdown can render async, so an
        // element missing on the first read may exist on subsequent frames.
        var resolveSections = function () {
            return activeTab.headings
                .map(function (h) { return ({
                id: h.id,
                el: document.getElementById(paneKey + "-" + h.id),
            }); })
                .filter(function (s) { return s.el !== null; });
        };
        // Local trackers to guard setState — prevents re-renders when value hasn't changed
        var currentActiveId = null;
        var currentProgress = -1;
        var rafHandle = null;
        var computeProgress = function () {
            // Use the document scroll metrics — the page is the scroll container,
            // and these values stay accurate regardless of when markdown finishes
            // laying out, so the initial reload value tracks the user's scrolling.
            var docEl = document.documentElement;
            var scrollTop = window.scrollY || docEl.scrollTop || 0;
            var total = docEl.scrollHeight - window.innerHeight;
            if (total <= 0) {
                return 0;
            }
            return Math.min(100, Math.max(0, Math.round((scrollTop / total) * 100)));
        };
        var handleScroll = function () {
            // RAF throttle — at most one execution per animation frame
            if (rafHandle !== null) {
                return;
            }
            rafHandle = requestAnimationFrame(function () {
                rafHandle = null;
                // Active heading: last section whose top has crossed 25% of the viewport
                var sections = resolveSections();
                var readingLine = window.innerHeight * 0.25;
                var newActiveId = null;
                for (var _i = 0, sections_1 = sections; _i < sections_1.length; _i++) {
                    var _a = sections_1[_i], id = _a.id, el = _a.el;
                    if (el.getBoundingClientRect().top <= readingLine) {
                        newActiveId = id;
                    }
                }
                if (newActiveId !== currentActiveId) {
                    currentActiveId = newActiveId;
                    setActiveHeadingId(newActiveId);
                }
                var progress = computeProgress();
                if (progress !== currentProgress) {
                    currentProgress = progress;
                    setReadingProgress(progress);
                }
            });
        };
        handleScroll();
        window.addEventListener('scroll', handleScroll, { passive: true });
        window.addEventListener('resize', handleScroll, { passive: true });
        // Observe the document body so we recompute progress whenever the page
        // height changes (async markdown layout, lazy images, fonts, etc.).
        var resizeObserver = null;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(handleScroll);
            resizeObserver.observe(document.body);
        }
        return function () {
            if (rafHandle !== null) {
                cancelAnimationFrame(rafHandle);
            }
            if (resizeObserver) {
                resizeObserver.disconnect();
            }
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleScroll);
            setActiveHeadingId(null);
            setReadingProgress(0);
        };
    }, [activeTabKey, visibleColumnCount, tabs]);
    react_1.useEffect(function () {
        var container = sidebarInnerRef.current;
        if (!container || !activeHeadingId) {
            return;
        }
        var activeLink = container.querySelector("[data-heading-id=\"" + activeHeadingId + "\"]");
        if (!activeLink) {
            return;
        }
        var scrollTarget = activeLink.offsetTop - container.clientHeight / 2 + activeLink.clientHeight / 2;
        container.scrollTo({ top: scrollTarget, behavior: 'smooth' });
    }, [activeHeadingId]);
    var updatePaneTab = function (paneIndex, tabKey) {
        setPaneTabKeys(function (currentKeys) {
            var nextKeys = __spreadArrays(currentKeys);
            nextKeys[paneIndex] = tabKey;
            return nextKeys;
        });
    };
    var getTabTitle = function (tab, tabIndex) {
        return tabIndex + 1 + ". " + tab.title;
    };
    var handleMultiColumnResizeStart = function (event) {
        event.preventDefault();
        resizeStartRef.current = {
            startY: event.clientY,
            startHeight: multiColumnPaneHeight,
        };
        setIsResizingColumns(true);
    };
    var buildVisibleExportText = function () {
        var visibleTabs = paneTabKeys
            .slice(0, visibleColumnCount)
            .map(function (tabKey) { return tabs.find(function (tab) { return tab.key === tabKey; }); })
            .filter(function (tab) { return !!tab; });
        return visibleTabs.map(function (tab) { return use_case_details_utils_1.buildTabExportText(tab); }).join('\n\n=====\n\n');
    };
    var exportVisibleText = function () {
        var file = new Blob([buildVisibleExportText()], {
            type: 'text/plain;charset=utf-8',
        });
        FileSaver.saveAs(file, params.useCaseId + "-use-case-report.txt");
    };
    var handleOpenWorkItem = react_1.useCallback(function () {
        if (!targetSystemWorkItemId) {
            return;
        }
        var workItemUrl = "https://dev.azure.com/" + encodeURIComponent(use_case_details_constants_1.AZURE_DEVOPS_ORGANISATION) + "/" + encodeURIComponent(use_case_details_constants_1.AZURE_DEVOPS_PROJECT) + "/_workitems/edit/" + encodeURIComponent(targetSystemWorkItemId);
        window.open(workItemUrl, '_blank', 'noopener,noreferrer');
    }, [targetSystemWorkItemId]);
    var handleOptimise = react_1.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsOptimising(true);
                    setActionMessage(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, config_1.getApiPut()("/ai/ukdc/use-cases/" + encodeURIComponent(params.useCaseId) + "/optimise", {})];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, refreshOutput(false)];
                case 3:
                    _a.sent();
                    setActionMessage({
                        text: 'Use case optimisation completed successfully.',
                        type: office_ui_fabric_react_1.MessageBarType.success,
                    });
                    return [3 /*break*/, 6];
                case 4:
                    error_1 = _a.sent();
                    setActionMessage({
                        text: error_1 instanceof Error ? error_1.message : 'Failed to optimise use case.',
                        type: office_ui_fabric_react_1.MessageBarType.error,
                    });
                    return [3 /*break*/, 6];
                case 5:
                    setIsOptimising(false);
                    setTimeout(function () { return setActionMessage(null); }, 5000);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); }, [params.useCaseId, refreshOutput]);
    var handleStartAnalysis = react_1.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsAnalysing(true);
                    setActionMessage(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, config_1.getApiPut()("/ai/ukdc/use-cases/" + encodeURIComponent(params.useCaseId) + "/analyse", {})];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, refreshOutput(false)];
                case 3:
                    _a.sent();
                    setActionMessage({
                        text: 'Use case analysis started successfully.',
                        type: office_ui_fabric_react_1.MessageBarType.success,
                    });
                    return [3 /*break*/, 6];
                case 4:
                    error_2 = _a.sent();
                    setActionMessage({
                        text: error_2 instanceof Error ? error_2.message : 'Failed to start use case analysis.',
                        type: office_ui_fabric_react_1.MessageBarType.error,
                    });
                    return [3 /*break*/, 6];
                case 5:
                    setIsAnalysing(false);
                    setTimeout(function () { return setActionMessage(null); }, 5000);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); }, [params.useCaseId, refreshOutput]);
    /**
     * Wait for an in-flight extraction run to reach a terminal status,
     * keep the "Syncing..." loader visible while it does, and refresh
     * the markdown highlights once it completes.
     *
     * Shared by:
     *  - {@link handleSyncAnalysis} — after the user clicks Sync.
     *  - The mount effect — when the page is loaded mid-extraction
     *    (user reloaded, navigated back, or another tab kicked it
     *    off), so the loader and disabled button are restored without
     *    requiring the user to keep the original tab open.
     */
    var trackExtractionRun = react_1.useCallback(function (runId, initialStatus, isCancelled) {
        if (initialStatus === void 0) { initialStatus = 'queued'; }
        return __awaiter(void 0, void 0, void 0, function () {
            var finalRun, finalStatus, items;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setIsSyncingAnalysis(true);
                        setExtractionRunStatus(initialStatus);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, , 4, 5]);
                        return [4 /*yield*/, extraction_run_service_1.pollExtractionRun(runId, {
                                onUpdate: function (snapshot) { return setExtractionRunStatus(snapshot.status); },
                                isCancelled: isCancelled,
                            })];
                    case 2:
                        finalRun = _b.sent();
                        if (isCancelled === null || isCancelled === void 0 ? void 0 : isCancelled()) {
                            return [2 /*return*/];
                        }
                        finalStatus = (_a = finalRun === null || finalRun === void 0 ? void 0 : finalRun.status) !== null && _a !== void 0 ? _a : null;
                        return [4 /*yield*/, use_case_highlights_service_1.fetchUseCaseHighlights(params.useCaseId)];
                    case 3:
                        items = _b.sent();
                        if (isCancelled === null || isCancelled === void 0 ? void 0 : isCancelled()) {
                            return [2 /*return*/];
                        }
                        setHighlightItems(items);
                        if (finalStatus === 'success') {
                            setActionMessage({
                                text: "Analysis synchronised and " + items.length + " element reference" + (items.length === 1 ? '' : 's') + " extracted (run #" + runId + ").",
                                type: office_ui_fabric_react_1.MessageBarType.success,
                            });
                        }
                        else if (finalStatus) {
                            setActionMessage({
                                text: "Analysis synchronised, but element extraction finished with status \"" + finalStatus + "\" (run #" + runId + ").",
                                type: office_ui_fabric_react_1.MessageBarType.warning,
                            });
                        }
                        else {
                            setActionMessage({
                                text: "Analysis synchronised. Element extraction is still running (run #" + runId + "); refresh later.",
                                type: office_ui_fabric_react_1.MessageBarType.warning,
                            });
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        if (!(isCancelled === null || isCancelled === void 0 ? void 0 : isCancelled())) {
                            setIsSyncingAnalysis(false);
                            setExtractionRunStatus(null);
                            setTimeout(function () { return setActionMessage(null); }, 5000);
                        }
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }, [params.useCaseId]);
    // Restore the "Syncing..." loader when the page loads while an
    // extraction run is still in flight (e.g. the user reloaded mid-
    // sync, opened the page in a second tab, or another teammate
    // triggered Sync Analysis on the same use case). The backend
    // exposes the active run via GET /extraction/use-cases/:id/active-run
    // and 204s when there is none, so a quiet `null` is the happy path.
    react_1.useEffect(function () {
        if (!params.useCaseId) {
            return undefined;
        }
        var cancelled = false;
        extraction_run_service_1.fetchActiveExtractionRun(params.useCaseId).then(function (active) {
            if (cancelled || !active) {
                return;
            }
            void trackExtractionRun(active.id, active.status, function () { return cancelled; });
        });
        return function () {
            cancelled = true;
        };
    }, [params.useCaseId, trackExtractionRun]);
    /**
     * Resolve the section heading nearest to a DOM node so the manual
     * mention can be persisted with a meaningful `section` (matches the
     * heading-id convention used by `renderMarkdownTabContent`). Falls
     * back to `'manual-selection'` when no section ancestor is found.
     */
    var resolveSectionForNode = react_1.useCallback(function (node) {
        var current = node;
        while (current && current.nodeType !== Node.ELEMENT_NODE) {
            current = current.parentNode;
        }
        while (current instanceof HTMLElement) {
            var id = current.id;
            if (id && id.startsWith('pane-')) {
                // id shape: `pane-{n}-{sectionId}` → strip pane prefix to
                // recover the original section id.
                var stripped = id.replace(/^pane-\d+-/, '');
                if (stripped && stripped !== id) {
                    return stripped;
                }
            }
            current = current.parentElement;
        }
        return 'manual-selection';
    }, []);
    /**
     * Listen for text selections inside the markdown reader. Shows the
     * SelectionPopup anchored at the selection rectangle. Selections
     * outside the reader (e.g. headers, sidebar) are ignored.
     */
    react_1.useEffect(function () {
        var handleMouseUp = function (event) {
            if (event.target instanceof Element &&
                event.target.closest('.ws-ai-hub-selection-popup, .ms-Callout, .ms-Layer')) {
                return;
            }
            // Defer one tick — `getSelection()` can lag on click-drag-release.
            window.setTimeout(function () {
                var selection = window.getSelection();
                if (!selection || selection.isCollapsed || selection.rangeCount === 0) {
                    return;
                }
                var text = selection.toString().trim();
                if (text.length === 0 || text.length > 2000) {
                    return;
                }
                var range = selection.getRangeAt(0);
                var root = readerRootRef.current;
                if (!root || !root.contains(range.commonAncestorContainer)) {
                    return;
                }
                var rect = range.getBoundingClientRect();
                if (rect.width === 0 && rect.height === 0) {
                    return;
                }
                var section = resolveSectionForNode(range.startContainer);
                setSelectionAnchor({
                    x: rect.left + rect.width / 2 - 160,
                    y: rect.bottom + 8,
                    text: text,
                    section: section,
                });
            }, 0);
        };
        document.addEventListener('mouseup', handleMouseUp);
        return function () {
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, [resolveSectionForNode]);
    var handleSelectionDismiss = react_1.useCallback(function () {
        setSelectionAnchor(null);
    }, []);
    var handleSelectionSubmit = react_1.useCallback(function (input) { return __awaiter(void 0, void 0, void 0, function () {
        var response_1, verb, error_3;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!selectionAnchor) {
                        return [2 /*return*/];
                    }
                    setIsSavingSelection(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, manual_elements_service_1.addManualElement(params.useCaseId, {
                            elementType: input.elementType,
                            canonicalName: input.canonicalName,
                            description: input.description,
                            section: selectionAnchor.section,
                            excerpt: selectionAnchor.text,
                        })];
                case 2:
                    response_1 = _b.sent();
                    // Optimistically append so the new highlight is visible
                    // immediately without a round-trip refetch.
                    setHighlightItems(function (current) { return __spreadArrays(current, [response_1.item]); });
                    setSelectionAnchor(null);
                    verb = response_1.created ? 'created' : 'linked to existing element';
                    setActionMessage({
                        text: "Element \"" + response_1.item.canonicalName + "\" " + verb + ".",
                        type: office_ui_fabric_react_1.MessageBarType.success,
                    });
                    setTimeout(function () { return setActionMessage(null); }, 4000);
                    // Clear the browser selection so the highlight is visible.
                    (_a = window.getSelection()) === null || _a === void 0 ? void 0 : _a.removeAllRanges();
                    return [3 /*break*/, 5];
                case 3:
                    error_3 = _b.sent();
                    setActionMessage({
                        text: error_3 instanceof Error
                            ? "Failed to add element: " + error_3.message
                            : 'Failed to add element.',
                        type: office_ui_fabric_react_1.MessageBarType.error,
                    });
                    setTimeout(function () { return setActionMessage(null); }, 5000);
                    return [3 /*break*/, 5];
                case 4:
                    setIsSavingSelection(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [params.useCaseId, selectionAnchor]);
    var handleSyncAnalysis = react_1.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, extraction, runId, error_4;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setIsSyncingAnalysis(true);
                    setExtractionRunStatus('queued');
                    setActionMessage(null);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 7, , 8]);
                    return [4 /*yield*/, config_1.getApiPut()("/ai/ukdc/use-cases/" + encodeURIComponent(params.useCaseId) + "/sync-analysis", {})];
                case 2:
                    response = _b.sent();
                    return [4 /*yield*/, refreshOutput(false)];
                case 3:
                    _b.sent();
                    extraction = (_a = response) === null || _a === void 0 ? void 0 : _a.extraction;
                    runId = extraction === null || extraction === void 0 ? void 0 : extraction.runId;
                    if (!runId) return [3 /*break*/, 5];
                    // Defer to the shared tracker; it owns the loader/banner/
                    // highlight refresh state machine.
                    return [4 /*yield*/, trackExtractionRun(runId, 'queued')];
                case 4:
                    // Defer to the shared tracker; it owns the loader/banner/
                    // highlight refresh state machine.
                    _b.sent();
                    return [3 /*break*/, 6];
                case 5:
                    setActionMessage({
                        text: 'Analysis synchronisation completed successfully.',
                        type: office_ui_fabric_react_1.MessageBarType.success,
                    });
                    setIsSyncingAnalysis(false);
                    setExtractionRunStatus(null);
                    setTimeout(function () { return setActionMessage(null); }, 5000);
                    _b.label = 6;
                case 6: return [3 /*break*/, 8];
                case 7:
                    error_4 = _b.sent();
                    setActionMessage({
                        text: error_4 instanceof Error ? error_4.message : 'Failed to sync analysis.',
                        type: office_ui_fabric_react_1.MessageBarType.error,
                    });
                    setIsSyncingAnalysis(false);
                    setExtractionRunStatus(null);
                    setTimeout(function () { return setActionMessage(null); }, 5000);
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    }); }, [params.useCaseId, refreshOutput, trackExtractionRun]);
    var dlaRelatedFeatures = react_1.useMemo(function () {
        var _a;
        var features = (_a = useCaseOutput === null || useCaseOutput === void 0 ? void 0 : useCaseOutput.AiUseCase) === null || _a === void 0 ? void 0 : _a.relatedFeatures;
        return Array.isArray(features) ? features : [];
    }, [(_g = useCaseOutput === null || useCaseOutput === void 0 ? void 0 : useCaseOutput.AiUseCase) === null || _g === void 0 ? void 0 : _g.relatedFeatures]);
    var dlaTreeData = react_1.useMemo(function () {
        var _a, _b;
        var rawEpicId = (_a = useCaseOutput === null || useCaseOutput === void 0 ? void 0 : useCaseOutput.AiUseCase) === null || _a === void 0 ? void 0 : _a.epicItemId;
        var epicId = typeof rawEpicId === 'string' ? rawEpicId.trim() : '';
        if (!epicId || dlaRelatedFeatures.length === 0) {
            return null;
        }
        return {
            epic: {
                id: epicId,
                label: ((_b = useCaseOutput === null || useCaseOutput === void 0 ? void 0 : useCaseOutput.AiUseCase) === null || _b === void 0 ? void 0 : _b.title) || "Use case " + params.useCaseId,
                url: buildAdoWorkItemUrl(epicId),
                features: dlaRelatedFeatures.map(function (feature) { return ({
                    id: String(feature.workItemId),
                    label: feature.title,
                    url: buildAdoWorkItemUrl(String(feature.workItemId)),
                    stories: (feature.userStories || []).map(function (story) { return ({
                        id: String(story.workItemId),
                        label: story.title,
                        url: buildAdoWorkItemUrl(String(story.workItemId)),
                    }); }),
                }); }),
            },
        };
    }, [
        dlaRelatedFeatures,
        params.useCaseId,
        (_h = useCaseOutput === null || useCaseOutput === void 0 ? void 0 : useCaseOutput.AiUseCase) === null || _h === void 0 ? void 0 : _h.epicItemId,
        (_j = useCaseOutput === null || useCaseOutput === void 0 ? void 0 : useCaseOutput.AiUseCase) === null || _j === void 0 ? void 0 : _j.title,
    ]);
    var dlaDocuments = react_1.useMemo(function () {
        return dlaRelatedFeatures.flatMap(function (feature) {
            var featureId = String(feature.workItemId);
            var documents = [];
            if (feature.fddDocumentLink) {
                documents.push({
                    id: featureId + "-fdd",
                    fileName: "DLA_FDD_FEATURE_" + featureId + ".docx",
                    url: feature.fddDocumentLink,
                });
            }
            if (feature.tddDocumentLink) {
                documents.push({
                    id: featureId + "-tdd",
                    fileName: "DLA_TDD_FEATURE_" + featureId + ".docx",
                    url: feature.tddDocumentLink,
                });
            }
            return documents;
        });
    }, [dlaRelatedFeatures]);
    var isDlaReady = !!dlaTreeData;
    var renderDlaTabContent = function () {
        return (react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-dla" },
            react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-dla-header" },
                react_1.default.createElement(office_ui_fabric_react_1.Text, { variant: "xLarge" }, "DLA"),
                react_1.default.createElement(office_ui_fabric_react_1.Text, { className: "ws-ai-hub-use-case-details-dla-subtitle" }, "Verifies whether required Azure DevOps artefacts are available for downstream processing.")),
            isDlaReady ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(office_ui_fabric_react_1.MessageBar, { messageBarType: office_ui_fabric_react_1.MessageBarType.info, isMultiline: false }, "DLA requirements are satisfied. Required artefacts are available."),
                dlaTreeData && react_1.default.createElement(DlaTree_1.WsDlaTree, { data: dlaTreeData }),
                dlaDocuments.length > 0 && (react_1.default.createElement("section", { className: "ws-ai-hub-use-case-details-dla-documents", "aria-label": "Documents to download" },
                    react_1.default.createElement(office_ui_fabric_react_1.Text, { variant: "mediumPlus" }, "Documents"),
                    react_1.default.createElement("ul", { className: "ws-ai-hub-use-case-details-dla-documents-list" }, dlaDocuments.map(function (document) { return (react_1.default.createElement("li", { key: document.id, className: "ws-ai-hub-use-case-details-dla-documents-item" },
                        react_1.default.createElement("span", { "aria-hidden": "true", className: "ws-ai-hub-use-case-details-dla-documents-icon" }, "W"),
                        react_1.default.createElement("a", { href: document.url, target: "_blank", rel: "noreferrer", download: true }, document.fileName))); })))))) : (react_1.default.createElement(office_ui_fabric_react_1.MessageBar, { messageBarType: office_ui_fabric_react_1.MessageBarType.info }, DLA_PENDING_MESSAGE))));
    };
    var renderMarkdownTabContent = function (tab, paneKey) {
        return tab.sections.map(function (section) { return (react_1.default.createElement("div", { key: paneKey + "-" + section.id, id: paneKey + "-" + section.id, className: "ws-ai-hub-use-case-details-markdown-section" },
            react_1.default.createElement(react_markdown_preview_1.default, { source: section.markdown, className: "ws-ai-hub-use-case-details-markdown", components: markdownComponents, rehypePlugins: [use_case_details_utils_1.rehypeSanitizeMarkdown] }))); });
    };
    var renderMarkdownSections = function (sections, paneKey) {
        return sections.map(function (section) { return (react_1.default.createElement("div", { key: paneKey + "-" + section.id, id: paneKey + "-" + section.id, className: "ws-ai-hub-use-case-details-markdown-section" },
            react_1.default.createElement(react_markdown_preview_1.default, { source: section.markdown, className: "ws-ai-hub-use-case-details-markdown", components: markdownComponents, rehypePlugins: [use_case_details_utils_1.rehypeSanitizeMarkdown] }))); });
    };
    var renderAllTabSectionHeader = function (title, tabIndex) {
        return (react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-all-header" },
            react_1.default.createElement(office_ui_fabric_react_1.Text, { className: "ws-ai-hub-use-case-details-all-kicker" }, "Tab Content"),
            react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-all-title" }, tabIndex + 1 + ". " + title)));
    };
    var renderTabContent = function (tab, paneKey) {
        if (tab.kind === 'alignment') {
            return (react_1.default.createElement("div", { id: paneKey + "-alignment-graph" },
                react_1.default.createElement(UseCaseAlignment_1.WsUseCaseAlignment, { useCaseId: params.useCaseId, workflowId: alignmentWorkflowId, useCaseMetricNames: useCaseMetricNames, useCaseMetrics: useCaseMetrics, useCaseTitle: useCaseTitle })));
        }
        if (tab.kind === 'all') {
            var allPageTabs = tabs.filter(function (item) { return item.kind === 'markdown' && item.key !== 'dla'; });
            return (react_1.default.createElement(react_1.default.Fragment, null,
                allPageTabs.map(function (item, tabIndex) { return (react_1.default.createElement("div", { key: paneKey + "-" + item.key },
                    renderAllTabSectionHeader(item.title, tabIndex),
                    renderMarkdownTabContent(item, paneKey),
                    react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-all-divider" }))); }),
                react_1.default.createElement("div", { id: paneKey + "-alignment-graph", className: "ws-ai-hub-use-case-details-markdown-section" },
                    renderAllTabSectionHeader('Use Case Alignment', allPageTabs.length),
                    react_1.default.createElement(UseCaseAlignment_1.WsUseCaseAlignment, { useCaseId: params.useCaseId, workflowId: alignmentWorkflowId, useCaseMetricNames: useCaseMetricNames, useCaseMetrics: useCaseMetrics, useCaseTitle: useCaseTitle }))));
        }
        if (tab.key === 'dla') {
            return renderDlaTabContent();
        }
        if (tab.key === 'info' && tab.kind === 'markdown') {
            var _a = tab.sections, overviewSection = _a[0], remainingSections = _a.slice(1);
            var technologyStackIndex = remainingSections.findIndex(function (section) { return section.id === 'info-technology-stack'; });
            var sectionsBeforeProcess = technologyStackIndex >= 0
                ? remainingSections.slice(0, technologyStackIndex + 1)
                : remainingSections;
            var sectionsAfterProcess = technologyStackIndex >= 0 ? remainingSections.slice(technologyStackIndex + 1) : [];
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { id: paneKey + "-summary", className: "ws-ai-hub-use-case-details-markdown-section" },
                    react_1.default.createElement(SummarySection_1.WsSummarySection, { useCase: useCase, output: useCaseOutput, highlightText: inlineTextHighlighter })),
                overviewSection ? renderMarkdownSections([overviewSection], paneKey) : null,
                react_1.default.createElement("div", { id: paneKey + "-readiness", className: "ws-ai-hub-use-case-details-markdown-section" },
                    react_1.default.createElement(ReadlinessCharts_1.WsReadinessCharts, { technologyItems: technologyReadinessItems, dataSourceItems: dataSourceReadinessItems, readinessTotalScore: readinessTotalScore, highlightText: inlineTextHighlighter })),
                react_1.default.createElement("div", { id: paneKey + "-prioritisation", className: "ws-ai-hub-use-case-details-markdown-section" },
                    react_1.default.createElement(PrioritisationSection_1.WsPrioritisationSection, { useCase: useCase, useCases: props.useCases || [], strategies: strategies, readinessTotalScore: readinessTotalScore, highlightText: inlineTextHighlighter })),
                renderMarkdownSections(sectionsBeforeProcess, paneKey),
                processTimelinePoints.length > 0 ? (react_1.default.createElement("div", { id: paneKey + "-process", className: "ws-ai-hub-use-case-details-markdown-section" },
                    react_1.default.createElement(Timeline_1.WsTimeline, { points: processTimelinePoints, orientation: "vertical", showPointNumbers: true, highlightText: inlineTextHighlighter }))) : null,
                renderMarkdownSections(sectionsAfterProcess, paneKey)));
        }
        return react_1.default.createElement(react_1.default.Fragment, null, renderMarkdownTabContent(tab, paneKey));
    };
    var renderSidebar = function (tab, paneKey) {
        return (react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-sidebar" },
            react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-sidebar-inner", ref: sidebarInnerRef },
                react_1.default.createElement(office_ui_fabric_react_1.Text, { className: "ws-ai-hub-use-case-details-sidebar-title" }, "Contents"),
                react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-sidebar-list" }, tab.headings.map(function (heading) { return (react_1.default.createElement("a", { key: paneKey + "-" + heading.id, className: [
                        'ws-ai-hub-use-case-details-sidebar-link',
                        "ws-ai-hub-use-case-details-sidebar-link-level-" + heading.level,
                        heading.id === activeHeadingId
                            ? 'ws-ai-hub-use-case-details-sidebar-link--active'
                            : '',
                    ]
                        .filter(Boolean)
                        .join(' '), "data-heading-id": heading.id, href: "#" + paneKey + "-" + heading.id }, heading.text)); }))),
            react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-sidebar-progress" },
                react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-sidebar-progress-header" },
                    react_1.default.createElement(office_ui_fabric_react_1.Text, { className: "ws-ai-hub-use-case-details-sidebar-progress-label" }, "Reading Progress"),
                    react_1.default.createElement(office_ui_fabric_react_1.Text, { className: "ws-ai-hub-use-case-details-sidebar-progress-value" },
                        readingProgress,
                        "%")),
                react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-sidebar-progress-bar" },
                    react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-sidebar-progress-bar-fill", style: { width: readingProgress + "%" } })))));
    };
    var renderPane = function (tabKey, paneIndex) {
        var tab = tabs.find(function (item) { return item.key === tabKey; });
        if (!tab) {
            return null;
        }
        var paneKey = "pane-" + (paneIndex + 1);
        var shouldRenderSidebar = visibleColumnCount === 1 && tab.kind !== 'alignment' && tab.headings.length > 0;
        return (react_1.default.createElement("div", { key: paneKey, className: "ws-ai-hub-use-case-details-pane ws-ai-hub-use-case-details-scale-" + use_case_details_constants_1.FONT_SCALE_OPTIONS[fontScaleIndex], style: visibleColumnCount > 1 ? { height: multiColumnPaneHeight + "px" } : undefined },
            visibleColumnCount === 1 ? (react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-pane-tabs" },
                react_1.default.createElement("div", { className: "tabs is-boxed" },
                    react_1.default.createElement("ul", null, tabs.map(function (item, tabIndex) { return (react_1.default.createElement("li", { key: item.key, className: [
                            activeTabKey === item.key ? 'is-active' : '',
                            item.key === 'all' ? 'ws-ai-hub-use-case-details-tab-with-separator' : '',
                        ]
                            .filter(Boolean)
                            .join(' ') },
                        react_1.default.createElement("a", { href: "#tab", onClick: function (event) {
                                event.preventDefault();
                                updatePaneTab(0, item.key);
                            } }, getTabTitle(item, tabIndex)))); }))))) : (react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-pane-selector" },
                react_1.default.createElement(office_ui_fabric_react_1.Dropdown, { label: "Pane " + (paneIndex + 1), selectedKey: tab.key, options: tabs.map(function (item, tabIndex) { return ({
                        key: item.key,
                        text: getTabTitle(item, tabIndex),
                    }); }), onChange: function (event, option) {
                        updatePaneTab(paneIndex, "" + ((option === null || option === void 0 ? void 0 : option.key) || tab.key));
                    } }))),
            react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-pane-body " + (!shouldRenderSidebar ? 'ws-ai-hub-use-case-details-pane-body-no-sidebar' : '') },
                react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-pane-content" }, renderTabContent(tab, paneKey)),
                shouldRenderSidebar && renderSidebar(tab, paneKey))));
    };
    if (!useCase) {
        return react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-empty" }, "Use case not found.");
    }
    var syncingAnalysisLabel = (function () {
        switch (extractionRunStatus) {
            case 'queued':
                return 'Syncing analysis. Element extraction queued, please wait...';
            case 'running':
                return 'Syncing analysis. Extracting elements from the use case, this can take up to 1 minute...';
            case 'success':
                return 'Element extraction finished. Loading highlights...';
            case 'schema-failed':
            case 'agent-error':
            case 'timeout':
                return "Element extraction finished with status \"" + extractionRunStatus + "\". Cleaning up...";
            default:
                return 'Syncing analysis. Please wait, this can take up to 1 minute...';
        }
    })();
    var loadingLabel = isOptimising
        ? 'Optimizing use case. Please wait, this can take up to 1 minute...'
        : isAnalysing
            ? 'Starting analysis. Please wait, this can take up to 1 minute...'
            : isSyncingAnalysis
                ? syncingAnalysisLabel
                : use_case_details_constants_1.DEFAULT_OUTPUT_LOADING_LABEL;
    if (isLoadingOutput || isOptimising || isAnalysing || isSyncingAnalysis) {
        return (react_1.default.createElement(AiHubLoadingState_1.AiHubLoadingState, { label: loadingLabel, className: "ws-ai-hub-use-case-details-loading-screen", isFullScreen: true }));
    }
    return (react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details" },
        react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-header-card" },
            react_1.default.createElement(FlowBar_1.WsAiHubFlowBar, { steps: [
                    {
                        key: 'backlog',
                        number: 1,
                        label: 'Backlog',
                        isReady: true,
                        menuItems: [
                            {
                                key: 'open-work-item',
                                label: 'Open Work Item',
                                disabled: !targetSystemWorkItemId,
                                onClick: handleOpenWorkItem,
                            },
                        ],
                    },
                    {
                        key: 'qualification',
                        number: 2,
                        label: 'Qualification',
                        isReady: isQualificationStepReady,
                        menuItems: [
                            {
                                key: 'optimise',
                                label: isOptimiseActionReady
                                    ? isOptimising
                                        ? 'Re-optimising...'
                                        : 'Re-optimise'
                                    : isOptimising
                                        ? 'Optimising...'
                                        : 'Optimise',
                                isReady: isOptimiseActionReady,
                                disabled: isOptimising || isAnalysing || isSyncingAnalysis,
                                onClick: function () {
                                    void handleOptimise();
                                },
                            },
                            {
                                key: 'start-analysis',
                                label: isStartAnalysisActionReady
                                    ? isAnalysing
                                        ? 'Re-analysing...'
                                        : 'Re-analyse'
                                    : isAnalysing
                                        ? 'Analysing...'
                                        : 'Start analysis',
                                isReady: isStartAnalysisActionReady,
                                disabled: isOptimising || isAnalysing || isSyncingAnalysis,
                                onClick: function () {
                                    void handleStartAnalysis();
                                },
                            },
                            {
                                key: 'sync-analysis',
                                label: isSyncAnalysisActionReady
                                    ? isSyncingAnalysis
                                        ? 'Re-syncing...'
                                        : 'Re-sync analysis'
                                    : isSyncingAnalysis
                                        ? 'Syncing...'
                                        : 'Sync analysis',
                                isReady: isSyncAnalysisActionReady,
                                disabled: isOptimising || isAnalysing || isSyncingAnalysis,
                                onClick: function () {
                                    void handleSyncAnalysis();
                                },
                            },
                        ],
                    },
                    {
                        key: 'prioritization',
                        number: 3,
                        label: 'Prioritization',
                        isReady: isPrioritizationStepReady,
                    },
                    { key: 'definition', number: 4, label: 'Definition' },
                    { key: 'readiness', number: 5, label: 'Readiness' },
                    { key: 'implementation', number: 6, label: 'Implementation' },
                ] })),
        actionMessage && (react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-message" },
            react_1.default.createElement(office_ui_fabric_react_1.MessageBar, { messageBarType: actionMessage.type }, actionMessage.text))),
        outputError && (react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-message" },
            react_1.default.createElement(office_ui_fabric_react_1.MessageBar, { messageBarType: office_ui_fabric_react_1.MessageBarType.info }, outputError))),
        isQualificationStepReady && !isPopupHighlightDataReady && (react_1.default.createElement("div", { className: "ws-ai-hub-use-case-details-message" },
            react_1.default.createElement(office_ui_fabric_react_1.MessageBar, { messageBarType: office_ui_fabric_react_1.MessageBarType.info }, "Qualification reports are available. Popup highlights are still being prepared and will appear automatically."))),
        tabs.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { ref: readerRootRef, className: "ws-ai-hub-use-case-details-content ws-ai-hub-use-case-details-content-" + visibleColumnCount + " " + (isResizingColumns ? 'ws-ai-hub-use-case-details-content-is-resizing' : '') }, paneTabKeys
                .slice(0, visibleColumnCount)
                .map(function (tabKey, paneIndex) { return renderPane(tabKey, paneIndex); })),
            visibleColumnCount > 1 && (react_1.default.createElement(office_ui_fabric_react_1.TooltipHost, { content: "Drag to resize the split view height" },
                react_1.default.createElement("button", { type: "button", className: "ws-ai-hub-use-case-details-resize-handle", onMouseDown: handleMultiColumnResizeStart, "aria-label": "Resize split view height" },
                    react_1.default.createElement("span", { className: "ws-ai-hub-use-case-details-resize-handle-line" })))))),
        selectionAnchor && (react_1.default.createElement(SelectionPopup_1.WsSelectionPopup, { anchor: selectionAnchor, isSubmitting: isSavingSelection, onSubmit: handleSelectionSubmit, onDismiss: handleSelectionDismiss }))));
};
exports.WsAiHubUseCaseDetails = WsAiHubUseCaseDetails;
